<template>
  
  
  <Loader v-if="loading" />
  <div>
    <!-- Month Selector -->
        
      <div class="month-selector">
          <Button @click="prevMonth">Mese Precedente</button>
          <h2>{{ formattedMonth }}</h2>
          <Button @click="nextMonth">Mese Successivo</button>
        </div>
        <Loader v-if="loading" />
      <div v-if="courses && courses.length ==[] && !loading" class="text-center">
        <h4>Nessun pagamento da visualizzare per il mese selezionato {{ loading }}</h4> 
      </div>
    <!-- Accordion for Courses -->
    <Accordion :multiple="true" :activeIndex="activeIndex">
     
    <AccordionTab v-for="(course, index) in courses" :key="index" :header="index">
      <DataTable :value="getCombinedPayments(course)" responsiveLayout="scroll">
        <Column field="nome" header="Atleta">
          <template #body="{data}">
            <template v-if="!data.isSummaryRow">
                                    <Button @click="goToAtleta(data.id_atleta)"  class="p-button-link">
                               {{ capitalizeFirstLetter(data.nome) }} {{ capitalizeFirstLetter(data.cognome) }}</Button>
          </template>
          <template v-else>
            <b>Totale da pagare</b>
          </template>
          </template>
        </Column>
        <Column field="email" header="Email">
          <template #body="{data}">
            <template v-if="!data.isSummaryRow">
              {{ data.email }}
            </template>
          </template>
        </Column>
        
        <Column field="presenze" header="Presenze dall'inizio"></Column>
        <Column field="presenze30" header="Presenze nel mese"></Column>
        <Column field="data_pagamento" header="Data Pagamento">
          <template #body="{data}" >
            <template v-if="!data.isSummaryRow">
            {{ data.data_pagamento ? moment(data.data_pagamento).format('DD/MM/YYYY') : '-' }}
            </template>

          </template>
        </Column>

        <Column field="data_scadenza" header="Data Scadenza">
          <template #body="{data}">
            <template v-if="!data.isSummaryRow">
            {{ moment(data.data_scadenza).format('DD/MM/YYYY') }}
          </template>
          </template>
        </Column>
        
        <Column field="importo" header="Importo">
          <template #body="{data}">
            <template v-if="!data.isSummaryRow">
              {{ formatCurrency(data.importo) }}
            </template>
            <template v-else>
              <strong>{{ formatCurrency(data.totaleToPay) }}</strong>
            </template>
          </template>
        </Column>

        <Column field="stato" header="Stato">
          <template #body="{data}">
            <span :class="{'text-green-500': data.stato === 'Pagato', 'text-orange-600': data.stato === 'Da Pagare'}">
              {{ data.stato }}
            </span>
          </template>
        </Column>
        <Column header="Invia Reminder">
          <template #body="{data}">
            <template v-if="!data.isSummaryRow">
              <Button 
                v-if="data.stato === 'Da Pagare' && data.email && data.email.includes('@')"
                @click="sendPaymentReminder(data)"
                :disabled="loading"
              >
                <i class="pi pi-envelope" style="color:white"></i>
              </button>
            </template>
            <template v-else>
              <Button class="p-button p-button-danger"
                v-if="data.unpaidCount > 0"
                @click="sendMultipleReminders(data.unpaidPayments)"
                
                :disabled="loading"
              >
                <i class="pi pi-envelope mr-2" style="color:white"></i>
                Invia a tutti ({{ data.unpaidCount }})
              </button>
            </template>
          </template>
        </Column>
      </DataTable>
    </AccordionTab>
  </Accordion>
  </div>
</template>

<script>
import {ref, onMounted, getCurrentInstance,computed, watchEffect } from 'vue';
import Loader from "@/components/Loader.vue";
import Service from '@/services/levante-api/levante-api';
import { useToast } from 'primevue/usetoast';
import moment from 'moment'

export default {
  components: {
    Loader,
  },
  computed: {
    hasUnpaidPayments() {
      return this.courses.some(course => 
        course.topay && course.topay.length > 0
      );
    }
  }, 
  methods: {
    goToAtleta(idatleta){
      console.log(idatleta)
      window.open(`/atleta/${idatleta}/dettagli`, '_blank')
    },
    // Funzione per capitalizzare la prima lettera
    capitalizeFirstLetter(string) {
      if (!string) return ""; // Gestione stringa vuota o nulla
      return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
    },
    formatCurrency(value) {
      return new Intl.NumberFormat('it-IT', {
        style: 'currency',
        currency: 'EUR'
      }).format(value);
    },
    getCombinedPayments(course) {
      // Aggiungi lo stato 'Pagato' ai pagamenti effettuati
      const paymentsWithStatus = course.payments.map(payment => ({
        ...payment,
        stato: 'Pagato',
        isSummaryRow: false
      }));

      // Aggiungi lo stato 'Da Pagare' ai pagamenti da effettuare
      const toPayWithStatus = course.topay.map(payment => ({
        ...payment,
        stato: 'Da Pagare',
        isSummaryRow: false
      }));

      // Unisci i due array
      const combinedPayments= [...paymentsWithStatus, ...toPayWithStatus];


      // Calcola il totale da pagare e il conteggio dei pagamenti in sospeso
      const totaleToPay = course.topay.reduce((sum, payment) => sum + payment.importo, 0);
      
      // Aggiungi riga riepilogativa
      const summaryRow = {
        isSummaryRow: true,
        totaleToPay,
        unpaidCount: course.topay.length,
        unpaidPayments: course.topay,
      };

      return [...combinedPayments, summaryRow];
    },

    
  },
  setup() {
    const loading = ref(true);
    const toast = useToast();
    const courses = ref(null)
    const currentMonth = ref(new Date());
    const selectedMonth=ref()
    const today = new Date();
    const year = today.getFullYear();
    const month = (today.getMonth() + 1).toString().padStart(2, '0'); // Months are 0-indexed, so +1
    selectedMonth.value = `${year}-${month}-01`;

    const self = getCurrentInstance();
    const lifeTime = 3000;
    self.$eventBus = self.appContext.config.globalProperties.$eventBus
    const service = new Service(self.$eventBus)
 
    const initData = () => {

      fetchPaymentData(new Date());
    }
    const sendMultipleReminders= (payments) =>{
      try {
        loading.value = true;
        
        // Invia le email in sequenza
        for (const payment of payments) {
          let fd = new FormData();
          fd.append("userId", payment.id);
          fd.append("email", payment.email);
          
          service.sendReminderCorso(fd).then((res)=>{
          const severity = res.item.esito;
          const summary = res.item.esito !== 'success' ? 'Attenzione' : 'Successo';
          const detail = res.item.messaggio;
          
          if (severity !== 'warning') {
            toast.add({
              severity: severity,
              summary: summary,
              detail: detail,
              life: lifeTime
            });
          }
        });
        }

        toast.add({
          severity: 'success',
          summary: 'Completato',
          detail: `Invio reminder completato per ${payments.length} atleti`,
          life: lifeTime
        });

      } catch (error) {
        console.error('Errore nell\'invio delle email:', error);
        toast.add({
          severity: 'error',
          summary: 'Errore',
          detail: 'Si è verificato un errore nell\'invio delle email',
          life: lifeTime
        });
      } finally {
        loading.value = false;
      }
    }


    const  sendPaymentReminder = (payment) =>{
      try {
        loading.value = true;
        let fd = new FormData();
        fd.append("userId",payment.id);
        fd.append("email",payment.email);
        
          service.sendReminderCorso(fd).then((res)=>{
            let severity = res.item.esito
          let summary = res.item.esito != 'success' ? 'Attenzione' : 'Successo'
          let detail = res.item.messaggio
          
          if (severity != 'warning') {
            toast.add({severity:severity, summary: summary, detail:detail, life: lifeTime});   
                    
          }
        })
      } catch (error) {
        console.error('Errore nell\'invio dell\'email:', error);
        toast.add({
          severity: 'error',
          summary: 'Errore',
          detail: 'Impossibile inviare l\'email. Riprova più tardi.',
          life: 3000
        });
      } finally {
        loading.value = false;
      }
    }
    const fetchPaymentData = (mese)=>{
      loading.value = true
      courses.value=[]
      const year = mese.getFullYear();
      const month = (mese.getMonth() + 1).toString().padStart(2, '0'); // Months are 0-indexed, so +1
      mese =  `${year}-${month}-01`;
      service.getPagamentiCorsoMese(mese).then((res)=>{
        courses.value=res.items
        loading.value = false
      })
    }

    const fetchPayments = ()=>{
      console.log("fetchPayments")

      fetchPaymentData(currentMonth.value)
    }

    const formattedMonth = computed(() => {
      console.log(currentMonth)
      return currentMonth.value.toLocaleDateString('it-IT', { year: 'numeric', month: 'long' }).toUpperCase();
    });

    const prevMonth = () => {
      currentMonth.value = new Date(currentMonth.value.setMonth(currentMonth.value.getMonth() - 1));
    };

    const nextMonth = () => {
      currentMonth.value = new Date(currentMonth.value.setMonth(currentMonth.value.getMonth() + 1));
    };


    const combinedPayments = computed((c) =>{
      // Combine course.payments and course.topay with an added status field
      const payments = c.payments.map(payment => ({
        ...payment,
        status: 'Paid'
      }));
      const topay = c.topay.map(toPay => ({
        ...toPay,
        status: 'To Pay',
        data_pagamento: null  // No payment date for "To Pay" entries
      }));

      return [...payments, ...topay];
    }
  );

    const activeIndex = ref([]);

    watchEffect(() => {
      fetchPayments();
      activeIndex.value = []; // Reset accordion state when month changes
    });

    onMounted(() => { 
      loading.value = true
      const promises = [initData()]
      
      Promise.all(promises)
      .then(()=>{
          
      }).finally(()=>{
        //  loading.value = false
      })
    })




    return {
      sendPaymentReminder,sendMultipleReminders,
      loading,selectedMonth,courses,moment,nextMonth,prevMonth,formattedMonth,combinedPayments,activeIndex
    };
  },
}
</script>

<style scoped>
.month-selector {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

</style>
